import SearchFilter from './SearchFilter'
import Pagination from './Pagination'
import { getMinDashboardSessionDetail } from './SessionDetail'

export { getSessionSearch, SessionSearch } from '@fs/zion-rootstech'

export const getDashboardSessionSearch = (includeAudiences = false) => `
  ${SearchFilter}
  ${Pagination}
  ${getMinDashboardSessionDetail(includeAudiences)}
  fragment DashboardSessionSearch on SessionSearch {
    filters {
      ...SearchFilter
    }
    paginationData {
      ...Pagination
    }
    results {
      ...MinDashboardSessionDetail
    }
  }
`

export const DashboardSessionSearch = getDashboardSessionSearch(false)
